import toastr from "toastr"

function options() {
    return {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      onclick: null,
      showDuration: "300",
      hideDuration: "1000",
      timeOut: "5000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "slideDown",
      hideMethod: "fadeOut",
    };    
}

const noticeMessage = (type, title, content) => {
  toastr[type](content, title, options())
}

module.exports = { noticeMessage }